import ajax from './index'

// bc推广员列表
export function getBcList(url) {
  return ajax.get('/admin/soucard/search?' + url)
}
// bc推广员添加编辑
export function bcAddEdit(data) {
  return ajax.post('/admin/soucard/add', data)
}
// 查看bc卡列表
export function getLookBcList(url) {
  return ajax.get('/admin/soucard/binding?' + url)
}
// bc推广员解绑卡
export function setUnbundling(data) {
  return ajax.post('/admin/soucard/set_unbundling', data)
}
// bc推广员解绑卡+转移卡
export function unbundlingMove(data) {
  return ajax.post('/admin/soucard/get_saler', data)
}
// 查看红包卡列表
export function getLookRedList(url) {
  return ajax.get('/admin/soucard/get_card_list?' + url)
}
// 红包卡转移记录
export function getMoveRecord(url) {
  return ajax.get('/admin/soucard/transfer?' + url)
}
// 红包卡激活明细
export function activationList(url) {
  return ajax.get('/admin/soucard/activation_list?' + url)
}
// 查看红包卡激活详情
export function activationCardList(url) {
  return ajax.get('/admin/soucard/activation_card_list?' + url)
}
